import { useState } from "react";
import { useRecoilState } from "recoil";
import { sortOrderAtom } from "../../../state/search-state";
import { useTranslation } from "../../../fe-ui/hooks/use-translation";
// @mui
import { IconButton, Tooltip, MenuItem } from "@mui/material";
// components
import Iconify from "../../../fe-ui/atoms/Iconify/Iconify";
import MenuPopover from "../../components/menu-popover";

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function SidebarSortWidget() {
  const [sortOrder, setSortOrder] = useRecoilState(sortOrderAtom);
  const t = useTranslation();

  const OPTIONS = [
    { value: "asc", label: t("price_asc") },
    { value: "desc", label: t("price_desc") }
  ];

  const [openPopover, setOpenPopover] = useState<HTMLElement | null>(null);

  const handleOpenPopover = (event: React.MouseEvent<HTMLElement>) => {
    setOpenPopover(event.currentTarget);
  };

  const handleClosePopover = () => {
    setOpenPopover(null);
  };

  const handleSort = value => {
    setSortOrder(value);
  };

  return (
    <>
      <Tooltip title={t("cta_sort")}>
        <IconButton onClick={handleOpenPopover} data-testid="sort-button">
          <Iconify icon={sortOrder === "asc" ? "iconoir:sort-up" : "iconoir:sort-down"} />
        </IconButton>
      </Tooltip>

      <MenuPopover open={openPopover} onClose={handleClosePopover}>
        {OPTIONS.map(option => (
          <MenuItem
            key={option.value}
            selected={option.value === "featured"}
            onClick={() => {
              handleClosePopover();
              handleSort(option.value);
            }}
          >
            {option.label}
          </MenuItem>
        ))}
      </MenuPopover>
    </>
  );
}
